import type { RouteObject } from 'react-router';
import { RequerPermissao } from '@/app/RequerPermissao';
import { paginaSobDemanda } from '@/app/pagina-sob-demanda';

/**
 * Rotas de Pessoas, sob `RequerPermissao` de `pessoas.ver` como **rota-mãe** — toda ação do módulo exige
 * ver (decisão 1 da Implementacao). Cadastro e edição pedem, além disso, `pessoas.editar`.
 *
 * 🚨 Segunda tranca. A que vale é o `@Permissao()` de cada rota do backend; aqui só evitamos abrir uma tela
 * que o servidor negaria.
 *
 * `/pessoas/nova` vem **antes** de `/pessoas/:id`, senão "nova" seria lida como um id. Cada página carrega
 * sob demanda: quem não pode abrir Pessoas nem baixa o código delas.
 */
export const rotas: RouteObject[] = [
  {
    element: <RequerPermissao permissao="pessoas.ver" />,
    children: [
      {
        path: '/pessoas',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaPessoas'),
          (m) => m.PaginaPessoas,
          'Abrindo pessoas…',
        ),
      },
      {
        element: <RequerPermissao permissao="pessoas.editar" />,
        children: [
          {
            path: '/pessoas/nova',
            element: paginaSobDemanda(
              () => import('./paginas/PaginaPessoaNova'),
              (m) => m.PaginaPessoaNova,
              'Abrindo o cadastro…',
            ),
          },
          {
            path: '/pessoas/:id/editar',
            element: paginaSobDemanda(
              () => import('./paginas/PaginaPessoaEditar'),
              (m) => m.PaginaPessoaEditar,
              'Abrindo a edição…',
            ),
          },
        ],
      },
      {
        path: '/pessoas/:id',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaPessoaDetalhe'),
          (m) => m.PaginaPessoaDetalhe,
          'Abrindo a pessoa…',
        ),
      },
    ],
  },
];
